export const accessibilityString = (audience: string, artist: string) => {
    const isAudience = audience === 'Yes';
    const isArtist = artist === 'Yes';

    if(isAudience && isArtist){
        return 'Audience & Artist';
    }

    if(isAudience){
        return 'Audience only'
    }

    if(isAudience){
        return 'Artist only'
    }

    return 'Not accessible'
}